module.exports = {
  Position: require('@antv/attr/lib/position'),
  Shape: require('@antv/attr/lib/shape'),
  Size: require('@antv/attr/lib/size'),
  Color: require('./color')
};